
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import axios from '@/lib/axios';

const isServer = typeof window === 'undefined';


export const appSlice = createSlice({
    name: 'app',

    initialState: {
        user: null,
        roleActingAs: null,
        userEntityRoles: [],
        token: null,
        isAuthenticated: false,
        toasts: [],
        termsAccepted: false,
        privacyAccepted: false,
        acceptedPoll: null,
        jsonPollQuestion: null,
    },
    reducers: {
        setRoleActingAs(state, action)
        {
            // Update axios headers with the new role acting as
            if (action.payload?.id)
            {
                axios.defaults.headers.common['X-Role-Acting-As'] = action.payload.id;
            }
            const expiresAt = Date.now() + 5 * 60 * 1000;
            
            const roleActingAsWithExpiry = {...action.payload, expiresAt };
            return {
                ...state,
                roleActingAs: roleActingAsWithExpiry,
            };
        },
        setUser(state, action)
        {
            return {
                ...state,
                user: action.payload,
            };
        },

        updateUser(state, action)
        {
            state.user = {
                ...state.user,
                ...action.payload,
            };
        },

        setToken(state, action)
        {
            axios.defaults.headers.common['Authorization'] = `Bearer ${action.payload}`;
            return {
                ...state,
                token: action.payload,
            };
        },
        setIsAuthenticated(state, action)
        {
            return {
                ...state,
                isAuthenticated: action.payload,
            };
        },
        setUserAndToken(state, action)
        {
            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
            };
        },
        setUserEntityRoles(state, action)
        {
            return {
                ...state,
                userEntityRoles: action.payload,
            };
        },

        setJsonPollQuestion(state, action)
        {
            state.jsonPollQuestion = action.payload;
        },
        clearJsonPollQuestion(state)
        {
            state.jsonPollQuestion = null;
        },
        logOut(state)
        {
            return {
                ...state,
                user: null,
                token: null,
                userEntityRoles: [],
                roleActingAs: null,
                isAuthenticated: false,
                toasts: [],
            };
        },
        setPrivacyAccepted: (state, action) =>
        {
            state.privacyAccepted = action.payload;
        },
        setTermsAccepted: (state, action) =>
        {
            state.termsAccepted = action.payload;
        },
        setAcceptedPoll(state, action)
        {
            state.acceptedPoll = action.payload;
        },
        clearAcceptedPoll(state)
        {
            state.acceptedPoll = null;
        },
        clearRoleActingAs(state)
        {
            return {
                ...state,
                roleActingAs: null,
            };
        },
        addToast(state, action)
        {
            return {
                ...state,
                toasts: [...(state.toasts || []), action.payload],
            };
        },
        removeToast(state, action)
        {
            return {
                ...state,
                toasts: [],

            };
        }
    },

    extraReducers: (builder) =>
    {
        builder
            .addCase(HYDRATE, (state, action) =>
            {
                return {
                    ...state,
                    ...action.payload.app,
                    toasts: state.toasts || [],
                };
            });
    },
});